import BaseEntity from './BaseEntity';
export default class Plan extends BaseEntity {
    constructor(data) {
        super();
        this.annualPrice = null;
        this.annuallyPayment = null;
        this.expirationDate = null;
        this.licencesCount = null;
        this.licencesDebt = null;
        this.monthlyPrice = null;
        this.stripeCustomer = null;
        this.stripeSubscription = null;
        this.trialExpirationDate = null;
        this.subscriptionStartDate = null;
        if ('annualPrice' in data) {
            this.annualPrice = this.parseProperty(data, 'annualPrice');
        }
        this.annuallyPayment = this.parseProperty(data, 'annuallyPayment');
        this.expirationDate = this.parseProperty(data, 'expirationISODate');
        this.id = this.parseProperty(data, 'id');
        this.isOwner = this.parseProperty(data, 'isOwner');
        if ('licencesCount' in data) {
            this.licencesCount = this.parseProperty(data, 'licencesCount');
        }
        if ('licencesDebt' in data) {
            this.licencesDebt = this.parseProperty(data, 'licencesDebt');
        }
        if ('monthlyPrice' in data) {
            this.monthlyPrice = this.parseProperty(data, 'monthlyPrice');
        }
        this.name = this.parseProperty(data, 'name');
        this.organizationId = this.parseProperty(data, 'organizationId');
        this.paymentStatus = this.parseProperty(data, 'paymentStatus');
        this.price = this.parseProperty(data, 'price');
        this.stripeCustomer = this.parseProperty(data, 'stripeCustomer');
        this.stripeSubscription = this.parseProperty(data, 'stripeSubscription');
        this.trialExpirationDate = this.parseProperty(data, 'trialExpirationISODate');
        this.type = this.parseProperty(data, 'type');
        this.subscriptionStartDate = this.parseProperty(data, 'subscriptionStartISODate');
    }
}
